export default __webpack_public_path__ + "static/media/hacken-io-logo.757303ec.svg";